export enum EstadoRefacturacion {
  Candidata,
  Pendiente,
  Revisado,
  Aprobado,
  Rechazado
}
